import React from "react";
import GridLine from "./GridExpenseLine/GridExpenseLine";
import { Typography, Box } from "@material-ui/core";

const CategoryGridExpense = (props) => {
  let category = JSON.parse(JSON.stringify(props.category));
  if (!props.load) category = [];

  if (category.length === 0) {
    return (
      <Box className="flex items-center justify-center h-64">
        <Typography variant="body1" className="text-slate-500">
          No category data available
        </Typography>
      </Box>
    );
  }

  return (
    <div className="w-full py-6">
      <div className="mb-6">
        <Typography
          variant="h5"
          className="font-bold text-slate-800 mb-2"
          style={{ fontSize: "1.5rem" }}
        >
          Category Breakdown
        </Typography>
        <Typography variant="body2" className="text-slate-600">
          Tap on a category to view individual expenses
        </Typography>
      </div>

      <div className="space-y-0">
        {category.map((line, key) => (
          <GridLine
            key={key}
            index={key}
            exp={line}
            symbol={props.symbol}
            categoriesWithBudget={props.categoriesWithBudget}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryGridExpense;
